var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"agency-content"},[_vm._v(_vm._s(_vm.userData.agency || ""))])}
var staticRenderFns = []

export { render, staticRenderFns }